// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__1nxpA","title":"styles_title__7hJBS","description":"styles_description__1TZDz","input_wrapper":"styles_input_wrapper__CdrXb"};